import React, { useLayoutEffect, useRef, useState } from 'react';
import { SubMenuContainer } from '../../styles/mobileDropdown.style';
import { ExternalLink, InternalLink } from '../../styles/dropdown.style';
import PageLink from '../PageLink';
import PropTypes from 'prop-types';

const MobileSubMenu = ({ active, menuItems, activeDropdownCategory }) => {
    const ref = useRef(null);
    const [submenuHeight, setSubmenuHeight] = useState(0);

    useLayoutEffect(() => {
        if (active && ref.current) {
            setSubmenuHeight(ref.current.scrollHeight);
        } else {
            setSubmenuHeight(0);
        }
    }, [active, menuItems, activeDropdownCategory]);

    return (
        <SubMenuContainer ref={ref} submenuHeight={submenuHeight} active={active}>
            {menuItems?.[activeDropdownCategory]?.map((item) =>
                item?.external ? (
                    <ExternalLink
                        href={item.link}
                        key={`${item.label}-${item.id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <PageLink item={item} />
                    </ExternalLink>
                ) : (
                    <InternalLink to={item.link} key={`${item.label}-${item.id}`}>
                        <PageLink item={item} />
                    </InternalLink>
                )
            )}
        </SubMenuContainer>
    );
};

MobileSubMenu.propTypes = {
    menuItems: PropTypes.array,
    activeDropdownCategory: PropTypes.string,
    active: PropTypes.bool,
};

export default MobileSubMenu;
